import React, { ReactNode } from "react";

function Container({
  children,
  className,
}: {
  children: ReactNode;
  className?: any;
}) {
  return <div className={`${className} container`}>{children}</div>;
}

export default Container;
